module.exports = __webpack_public_path__ + "img/851.bba3e953.png";